const { steps } = require('../../config');

function getUrlParams(options = { data: {}, summary: [], goToSimulator: false, locale: 'de' }) {
	let params;

	if (options.goToSimulator) {
		params = new URLSearchParams({
			redirect: `/account/simulator/?simulator=${JSON.stringify({
				state: options.data,
				ids: options.summary
			})}#/step/${steps.length}`,
			lang: options.locale
		});
	} else {
		params = new URLSearchParams({
			simulator: JSON.stringify({
				state: options.data,
				ids: options.summary
			}),
			lang: options.locale
		});
	}

	return params;
}

function getSignupUrl(options = { data: {}, summary: [], domain: '', locale: 'de' }) {
	const params = getUrlParams({
		data: options.data,
		summary: options.summary,
		locale: options.locale
	});

	return `${options.domain}/user/registration?${params}`;
}

function getLoginUrl(options = { data: {}, summary: [], domain: '', locale: 'de' }) {
	const params = getUrlParams({
		data: options.data,
		summary: options.summary,
		locale: options.locale,
		goToSimulator: true
	});

	return `${options.domain}/user/login?${params}`;
}

function getPrintUrl(options = { data: {}, summary: [], domain: '', locale: 'de' }) {
	const params = getUrlParams({
		data: options.data,
		summary: options.summary,
		locale: options.locale
	});

	return `${options.domain}/api/pdf/simulator.pdf?${params}`;
}

module.exports = {
	getSignupUrl,
	getLoginUrl,
	getPrintUrl
};
